import gql from "graphql-tag";

const LOGIN_MUTATION = gql`
  mutation signIn ($email: String!, $password: String!){
    signIn(email: $email, password: $password) {
      token
      user {
        id
        customer {
          id
          type
        }
      }
    }
  }
`;

export default LOGIN_MUTATION;
